import { useEffect, useState } from "react";
import { server } from "../../server";
import axios from "axios";
import { Link, useLocation, useNavigate } from "react-router-dom";
import QRCode from "qrcode";
import { getDecodedToken } from "../../auth";

function ViewStaff() {
  const user = getDecodedToken();
  const [error, setError] = useState(null);
  const { state } = useLocation();
  const staffId = state?.staffId;
  const [staffData, setStaffData] = useState(null);
  const [qrDataURL, setQrDataURL] = useState("");
  const userRole = user?.roles;
  const userId = user?.userId;

  useEffect(() => {
    const generateQR = async () => {
      try {
        const url = await QRCode.toDataURL(staffId);
        setQrDataURL(url);
      } catch (err) {
        console.error("QR Code generation failed:", err);
      }
    };

    if (staffId) {
      generateQR();
    }
  }, [staffId]);

  const [formData, setFormData] = useState({
    session: "2025-26",
    basicDetails: {
      initials: "",
      fullName: "",
      gender: "",
      fathersName: "",
      mothersName: "",
      spouseName: "",
      category: "",
      bloodGroup: "",
      religion: "",
      nationality: "",
      dob: "",
      doj: "",
      maritalStatus: "",
      mobNo: "",
      emailId: "",
      aadharNo: "",
      panNo: "",
      basicQualification: "",
      masterQualification: "",
      professionalQualification: "",
      correspondenceAddress: "",
      permanentAddress: "",
    },
    leaveDetails: {
      totalCl: "",
      clAvailed: "",
      totalMl: "",
      mlAvailed: "",
    },
    categoryDetails: {
      staffCategory: "",
      teacherType: "",
      classTeacher: "",
      section: "",
      designation: "",
      department: "",
    },
    payrollDetails: {
      basicPay: "",
      gradePay: "",
      vpf: "",
      busDeduction: "",
      esiApplied: "",
      hraApplied: "",
      taAllowanceApplied: "",
      bankAccountNumber: "",
      ifscCode: "",
    },
    pfDetails: {
      pfApplied: "",
      pfAccountNumber: "",
      pfJoiningDate: "",
      uanNumber: "",
      nomineeName: "",
      nomineeRelation: "",
    },
    transportFacility: {},
  });

  useEffect(() => {
    const fetchStaff = async () => {
      if (!staffId) {
        setError("Please enter Staff Id");
        return;
      }
      setLoading(true);
      setError(null);
      try {
        const response = await axios.post(
          `${server}/get_staff_data_mongodb`,
          { staffId: staffId },
          {
            headers: {
              Authorization: `${localStorage.getItem("token")}`,
              "Content-Type": "application/json",
            },
          }
        );
        const staffData = response.data?.["body-json"]?.body;
        if (staffData) {
          setStaffData(staffData);
        } else {
          setError("No Student Data Found");
          setStaffData(null);
        }
      } catch (err) {
        setError("Student not found or API error.");
        setStaffData(null);
      } finally {
        setLoading(false);
      }
    };

    fetchStaff();
  }, [staffId]);

  useEffect(() => {
    if (staffData) {
      setFormData((prev) => ({
        ...prev,
        basicDetails: {
          ...prev.basicDetails,
          ...staffData.basicDetails,
        },
        leaveDetails: {
          ...prev.leaveDetails,
          ...staffData.leaveDetails,
        },
        categoryDetails: {
          ...prev.categoryDetails,
          ...staffData.categoryDetails,
        },
        payrollDetails: {
          ...prev.payrollDetails,
          ...staffData.payrollDetails,
        },
        pfDetails: {
          ...prev.pfDetails,
          ...staffData.pfDetails,
        },
        transportFacility: {
          ...prev.transportFacility,
          ...staffData.transportFacility,
        },
      }));
    }
  }, [staffData]);

  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  return (
    <>
      <div id="db-wrapper">
        <main id="page-content">
          <div className="">
            <div class="container-fluid">
              <div class="row">
                <div class="col-lg-12 col-md-12 col-12">
                  <div class="m-3 mt-2 pt-1 d-flex justify-content-between">
                    <div class="d-flex align-items-center mt-2">
                      <span
                        onClick={() => window.history.back()}
                        class="back-button me-3 cursor-pointer"
                      >
                        <i className="bi bi-arrow-left fs-3"></i>
                      </span>
                      <nav aria-label="breadcrumb">
                        <h4 className="m-0 lh-sm">View Staff</h4>
                        <ol class="breadcrumb pe-3 lh-sm">
                          <li class="breadcrumb-item">
                            <a href="#">Human Resource</a>
                          </li>
                          <li class="breadcrumb-item">
                            <a href="#">Staff Directory</a>
                          </li>
                          <li
                            class="breadcrumb-item active"
                            aria-current="page"
                          >
                            View Staff
                          </li>
                        </ol>
                      </nav>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div>
            <div class="container-fluid mb-4">
              <div className="row g-2">
                <div className="col-lg-8">
                  <div className="profile-head-bg rounded-top-5 p-5 d-flex align-items-start">
                    <div>
                      <img
                        src={
                          staffData?.basicDetails?.staffImage ||
                          `/assets/images/profile.png`
                        }
                        alt="Image"
                        width="120"
                        height="120"
                        className="object-fit-cover rounded-5 mt-3 border border-3 border-white"
                      />
                      <div class="icon-shape icon-xxl bg-white border rounded-circle position-absolute ms-n4 mt-n1">
                        <img
                          src={qrDataURL}
                          className="rounded-circle"
                          alt="QR"
                          width="50"
                        />
                      </div>
                    </div>
                  </div>

                  <div className="p-5 rounded-bottom-5 bg-white pt-8 d-flex justify-content-between">
                    <div>
                      <h3 class="m-0 fs-4 lh-1">
                        {staffData?.basicDetails?.fullName
                          .toLowerCase()
                          .replace(/\b\w/g, (char) => char.toUpperCase())}
                        <i class="bi bi-check-circle fs-5 text-primary ms-2"></i>
                        <span className="badge bg-success-soft ms-5">
                          {staffData?.basicDetails?.gender}
                        </span>
                      </h3>
                      <p className="m-0 fs-5">
                        {staffId},{" "}
                        {new Date(
                          staffData?.basicDetails?.doj
                        ).toLocaleDateString("en-GB")}
                      </p>
                      <p className="mt-3 mb-0 text-danger lh-sm">
                        (+91) {staffData?.basicDetails?.mobNo}
                        <br />
                        <span className="text-lowercase">
                          {staffData?.basicDetails?.emailId}
                        </span>
                      </p>
                      <p className="m-0 lh-sm mt-1 text-capitalize">
                        {staffData?.presentAddress?.address
                          .toLowerCase()
                          .replace(/\b\w/g, (char) => char.toUpperCase())}
                      </p>
                    </div>
                  </div>

                  <div className="p-5 pb-3 rounded-5 mt-1 bg-white">
                    <div className="row g-2">
                      <div className="col-lg-6 col-12">
                        <span class="badge bg-danger-soft">
                          1. Basic Details
                        </span>
                        <div className="mt-3">
                          <ol>
                            <li className="lh-sm">
                              Staff Id &mdash;{" "}
                              <span className="text-dark">{staffId}</span>
                            </li>
                            <li className="lh-sm">
                              Full Name &mdash;{" "}
                              <span className="text-dark">
                                {formData?.basicDetails?.fullName}
                              </span>
                            </li>
                            <li className="lh-sm">
                              Gender &mdash;{" "}
                              <span className="text-dark">
                                {formData?.basicDetails?.gender}
                              </span>
                            </li>
                            <li className="lh-sm">
                              Father's Name &mdash;{" "}
                              <span className="text-dark">
                                {formData?.basicDetails?.fathersName}
                              </span>
                            </li>
                            <li className="lh-sm">
                              Mother's Name &mdash;{" "}
                              <span className="text-dark">
                                {formData?.basicDetails?.mothersName}
                              </span>
                            </li>
                            <li className="lh-sm">
                              Spouse Name &mdash;{" "}
                              <span className="text-dark">
                                {formData?.basicDetails?.spouseName}
                              </span>
                            </li>
                            <li className="lh-sm">
                              Blood Group &mdash;{" "}
                              <span className="text-dark">
                                {formData?.basicDetails?.bloodGroup}
                              </span>
                            </li>
                            <li className="lh-sm">
                              Religion &mdash;{" "}
                              <span className="text-dark">
                                {formData?.basicDetails?.religion}
                              </span>
                            </li>
                            <li className="lh-sm">
                              Nationality &mdash;{" "}
                              <span className="text-dark">
                                {formData?.basicDetails?.nationality}
                              </span>
                            </li>
                            <li className="lh-sm">
                              Date Of Birth &mdash;{" "}
                              <span className="text-dark">
                                {formData?.basicDetails?.dob}
                              </span>
                            </li>
                            <li className="lh-sm">
                              Date Of Joining &mdash;{" "}
                              <span className="text-dark">
                                {formData?.basicDetails?.doj}
                              </span>
                            </li>
                            <li className="lh-sm">
                              Marital Status &mdash;{" "}
                              <span className="text-dark">
                                {formData?.basicDetails?.maritalStatus}
                              </span>
                            </li>
                            <li className="lh-sm">
                              Mobile No &mdash;{" "}
                              <span className="text-dark">
                                {formData?.basicDetails?.mobNo}
                              </span>
                            </li>
                            <li className="lh-sm">
                              Email Id &mdash;{" "}
                              <span className="text-dark">
                                {formData?.basicDetails?.emailId}
                              </span>
                            </li>
                            <li className="lh-sm">
                              Aadhar No &mdash;{" "}
                              <span className="text-dark">
                                {formData?.basicDetails?.aadharNo}
                              </span>
                            </li>
                            <li className="lh-sm">
                              PAN No &mdash;{" "}
                              <span className="text-dark">
                                {formData?.basicDetails?.panNo}
                              </span>
                            </li>
                            <li className="lh-sm">
                              Basic Qualification &mdash;{" "}
                              <span className="text-dark">
                                {formData?.basicDetails?.basicQualification}
                              </span>
                            </li>
                            <li className="lh-sm">
                              Master Qualification &mdash;{" "}
                              <span className="text-dark">
                                {formData?.basicDetails?.masterQualification}
                              </span>
                            </li>
                            <li className="lh-sm">
                              Professional Qualification &mdash;{" "}
                              <span className="text-dark">
                                {
                                  formData?.basicDetails
                                    ?.professionalQualification
                                }
                              </span>
                            </li>
                          </ol>
                        </div>
                      </div>

                      <div className="col-lg-6 col-12">
                        <span class="badge bg-danger-soft">
                          2. Category Details
                        </span>
                        <div className="mt-3">
                          <ol>
                            <li className="lh-sm">
                              Staff Category &mdash;{" "}
                              <span className="text-dark">
                                {formData?.categoryDetails?.staffCategory}
                              </span>
                            </li>
                            <li className="lh-sm">
                              Class Teacher &mdash;{" "}
                              <span className="text-dark">
                                {formData?.categoryDetails?.classTeacher}
                              </span>
                            </li>
                            <li className="lh-sm">
                              Section &mdash;{" "}
                              <span className="text-dark">
                                {formData?.categoryDetails?.section || "NA"}
                              </span>
                            </li>
                            <li className="lh-sm">
                              Designation &mdash;{" "}
                              <span className="text-dark">
                                {formData?.categoryDetails?.designation}
                              </span>
                            </li>
                            <li className="lh-sm">
                              Department &mdash;{" "}
                              <span className="text-dark">
                                {formData?.categoryDetails?.department}
                              </span>
                            </li>
                          </ol>
                        </div>

                        <div>
                          <span class="badge bg-info-soft">
                            2. Leave Details
                          </span>
                          <div className="mt-3">
                            <ol>
                              <li className="lh-sm">
                                Total CL &mdash;{" "}
                                <span className="text-dark">
                                  {formData?.leaveDetails?.totalCl}
                                </span>
                              </li>
                              <li className="lh-sm">
                                CL Availed &mdash;{" "}
                                <span className="text-dark">
                                  {formData?.leaveDetails?.clAvailed}
                                </span>
                              </li>
                              <li className="lh-sm">
                                Total ML &mdash;{" "}
                                <span className="text-dark">
                                  {formData?.leaveDetails?.totalMl}
                                </span>
                              </li>
                              <li className="lh-sm">
                                ML Availed &mdash;{" "}
                                <span className="text-dark">
                                  {formData?.leaveDetails?.mlAvailed}
                                </span>
                              </li>
                            </ol>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="row g-2">
                      <div className="col-lg-6 col-12">
                        <span class="badge bg-danger-soft mt-2">
                          3. Address
                        </span>
                        <div className="mt-3">
                          <ol>
                            <li className="lh-sm">
                              Correspondence Address &mdash;{" "}
                              <span className="text-dark pe-5">
                                {(
                                  formData?.basicDetails
                                    ?.correspondenceAddress ||
                                  "Correspondence Address"
                                )
                                  .toLowerCase()
                                  .replace(/\b\w/g, (char) =>
                                    char.toUpperCase()
                                  )}
                              </span>
                            </li>
                            <br />
                            <li className="lh-sm">
                              Permanent Address &mdash;{" "}
                              <span className="text-dark pe-5">
                                {(
                                  formData?.basicDetails?.permanentAddress ||
                                  "Permanent Address"
                                )
                                  .toLowerCase()
                                  .replace(/\b\w/g, (char) =>
                                    char.toUpperCase()
                                  )}
                              </span>
                            </li>
                          </ol>
                        </div>
                      </div>

                      {(userRole?.includes("Master Admin") ||
                        userRole?.includes("Admin") ||
                        userRole?.includes("Sub Admin")) && (
                        <>
                          <div className="col-lg-6 col-12">
                            <span class="badge bg-success-soft mt-2">
                              4. Payroll & PF Details
                            </span>
                            <div className="mt-3">
                              <ol>
                                <li className="lh-sm">
                                  Basic Pay &mdash;{" "}
                                  <span className="text-dark">
                                    {formData?.payrollDetails?.basicPay}
                                  </span>
                                </li>
                                <li className="lh-sm">
                                  Grade Pay &mdash;{" "}
                                  <span className="text-dark">
                                    {formData?.payrollDetails?.bagradePaysicPay}
                                  </span>
                                </li>
                                <li className="lh-sm">
                                  VPF &mdash;{" "}
                                  <span className="text-dark">
                                    {formData?.payrollDetails?.vpf}
                                  </span>
                                </li>
                                <li className="lh-sm">
                                  Bank Account Number &mdash;{" "}
                                  <span className="text-dark">
                                    {
                                      formData?.payrollDetails
                                        ?.bankAccountNumber
                                    }
                                  </span>
                                </li>
                                <li className="lh-sm">
                                  IFSC Code &mdash;{" "}
                                  <span className="text-dark">
                                    {formData?.payrollDetails?.ifscCode}
                                  </span>
                                </li>
                                <li className="lh-sm">
                                  PF Account Number &mdash;{" "}
                                  <span className="text-dark">
                                    {formData?.pfDetails?.pfAccountNumber}
                                  </span>
                                </li>
                                <li className="lh-sm">
                                  PF Joining Date &mdash;{" "}
                                  <span className="text-dark">
                                    {formData?.pfDetails?.pfJoiningDate}
                                  </span>
                                </li>
                                <li className="lh-sm">
                                  UAN Number &mdash;{" "}
                                  <span className="text-dark">
                                    {formData?.pfDetails?.uanNumber}
                                  </span>
                                </li>
                              </ol>
                            </div>
                          </div>
                        </>
                      )}
                    </div>
                  </div>
                </div>

                <div className="col-lg-4">
                  <div className="bg-white rounded-5">
                    <div className="bg-dark px-5 py-4 rounded-top-5">
                      <div className="mb-2 mt-2">
                        <div className="d-flex justify-content-between align-items-center">
                          <div>
                            <h5 className="text-white fw-medium lh-1 m-0">
                              Track Payroll transactions at a glance.
                            </h5>
                            <h5 className="text-white fs-5 fw-light mb-0">
                              Payroll Details
                            </h5>
                          </div>
                          <Link
                            to="/collect-fees"
                            state={{
                              admissionNo: staffData?.admission_no,
                            }}
                            class="badge bg-light-soft mb-n8"
                          >
                            Payroll
                          </Link>
                        </div>
                        <p className="mb-0 mt-2 text-light fw-medium">
                          Amount paid to date
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </main>
      </div>
    </>
  );
}

export default ViewStaff;
